import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import InputWrapper from "../../layout/inputWrapper";
import ButtonWrapper from "../../components/Button";
import { Toast } from "@egovernments/digit-ui-react-components";
import {
  permissionTypeList,
  proposedSite,
  schemeNameList,
  subUsesTypeList,
  yesOrNo,
  subUseCommercialList,
  developmentAreaOption,
  schemeTypeList,
} from "../../../TCPForms/data";
import SortingAlphabatically from "../../reusableComponents/SortingAlphbatically";
import { Backdrop, Box, Fade, Modal, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSelfMapCheck } from "./useResidentialApplication";
import { set } from "lodash";
import { InfoBox } from "../../components/StyledComponent";

const Step1 = ({
  formData,
  userInfo,
  handleTabChange,
  id,
  officesList,
  villagesData,
  departmentList,
  isEmployee,
  applicationFlow,
  avpUnits,
  avpData,
}) => {
  const { t } = useTranslation();
  const { documents } = useSelector((state) => state.formMT);
  const tenantId = Digit.ULBService.getStateId() || "up";
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [open, setOpen] = useState(false);
  const [areaerror, setAreaError] = useState(false);
  const [widtherror, setWidthError] = useState(false);
  const [isFormDisabled, setIsFormDiabled] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [isNetAreaTouched, setIsNetAreaTouched] = useState(false);
  const history = useHistory();
  const isDa = applicationFlow === "DA";
  const defaultValues = {
    ...formData,
  };
  console.log("formData", formData, defaultValues);
  const { handleSubmit, control, setValue, watch, reset, getValues, setError, clearErrors } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const { isCreateMode, isLoading, selfMapExists } = useSelfMapCheck({ tenantId, id });
  console.log(isCreateMode, isLoading, selfMapExists, isEmployee, "selfMapExistsChecking", userInfo);
  const filterTehsilData = (masterData, authority) => {
    console.log("filterTehsilDataCalled", masterData, authority);

    const result = masterData
      ?.find((item) => item.authorityName === authority)
      ?.tehsils?.map((item) => ({ name: item.tehsilName, label: item.tehsilName, value: item.tehsilName }));
    console.log("resultTehsil", result);
    return result || [];
  };
  const filterVillagesData = (masterData, authority, tehsil) => {
    console.log("villagesFilteredData", authority, tehsil);
    const result = tehsil
      ? masterData
        ?.find((item) => item?.authorityName === authority)
        ?.tehsils?.find((item) => item?.tehsilName === tehsil)
        ?.villages?.map((item) => ({
          name: item,
          label: item,
          value: item,
        }))
      : null;
    return result || [];
  };
  const filterSchemeNames = (masterData, department, planOn) => {
    const schemeNameList = masterData
      ?.filter((item) => item.Name === department)
      .map((item) => item.ColonyGroups)
      .flat()
      .filter((item) => item.ColonyType === planOn)
      .map((item) => item.Colonies)
      .flat()
      .map((item) => {
        return { name: item, label: item, value: item };
      });
    console.log("schemeFilteredData", schemeNameList);

    return schemeNameList;
  };
  const updistricts = !isDistrictDataLoading && districtData?.filter((district) => !district.code?.includes("up"));
  useEffect(() => {
    setValue("documents", documents);
  }, [documents]);
  const [
    watchPlanOn,
    watchPlotDetail,
    watchZoneType,
    watchOffice,
    watchUnit,
    watchDistrict,
    watchTehsil,
    watchPermissionType,
    watchContainFAR,
    watchSchemeType,
    watchDevelopmentArea,
    watchplotSubdivided,
    watchplotinColonies,
  ] = watch([
    "proposalType",
    "plotNo",
    "zoneType",
    "selectedOffice",
    "selectedUnit",
    "district",
    "tehsil",
    "permissionType",
    "containFAR",
    "descriptionOfLand.schemeType",
    "developmentArea",
    "plotSubdivided",
    "plotinColonies",
  ]);
  const [maxLength, setMaxLength] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  // const handleDeclarationChange = (event) => {
  //   setDeclarationChecked(event.target.checked);
  // };
  const tehsils = filterTehsilData(villagesData, watchOffice ? watchOffice : "Lucknow Development Authority");
  const villages = filterVillagesData(villagesData, watchOffice ? watchOffice : "Lucknow Development Authority", watchTehsil);
  const schemeNames = filterSchemeNames(departmentList, watchOffice, watchPlanOn);
  console.log("schemesName", schemeNames);
  useEffect(() => {
    setValue("landInfo.owners.[0].correspondenceAddress.type", "CORRESPONDENCE");
    setValue("landInfo.owners.[0].mobileNumber", userInfo?.mobileNumber);
  }, []);

  useEffect(() => {
    const office = watchOffice?.split(" ")[0];
    if (isDa) {
      setValue("district", office);
      setValue("selectedCity", office);
      setValue("department", "DA");
    } else {
      setValue("department", "AVP");
    }
    setValue("landInfo.address.city", office);
    setValue("landInfo.address.locality.code", office);
  }, [watchOffice]);
  useEffect(() => {
    if (watchPlotDetail === "Khasra No." || watchPlotDetail === "Araji No.") {
      setValue("proposalType", "Others");
    }
  }, [watchPlotDetail]);

  const watchplotinMelaArea = watch("plotinMelaArea");
  const isScheme = watchSchemeType === "Scheme";
  const filterCities = (unit, masterData) => {
    const result = masterData
      ?.filter((item) => item.Unit === unit)?.[0]
      ?.Cities?.map((item) => {
        return { name: item.City, label: item.City, value: item.City };
      });
    return result;
  };
  const avpCities = filterCities(watchUnit, avpData);

  const onSubmit = (data) => {
    if (!id && selfMapExists) {
      setShowToast({
        key: "true",
        error: true,
        message: "File already submitted through this Number.",
      });
      return;
    }
    if (parseFloat(data.plotArea) > maxLength) {
      setError("plotArea", {
        type: "manual",
        message: `Plot Area should not exceed ${maxLength} sqmt.`,
      });
      return;
    }
    handleTabChange(1, data); // ✅ Submit if all good
  };
  const primaryUse = watch("primaryUse");
  useEffect(() => {
    if (primaryUse === "Residential") {
      setValue("activityProposed", "Row House-Single unit");
      setMaxLength(100);
    } else if (primaryUse === "Commercial") {
      setValue("activityProposed", "Retail Shop");
      setMaxLength(30);
    }
  }, [primaryUse, setValue]);

  const plotArea = watch("plotArea");
  const netPlotArea = watch("totalProposedArea");
  const roadWidth = watch("descriptionOfLand.landLength");
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Built-up area") {
      setMaxWidth(4);
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Non-Built-up area") {
      setMaxWidth(9);
    }
  }, [watchSchemeType, watchDevelopmentArea]);
  useEffect(() => {
    const value = parseFloat(plotArea);
    const row = parseFloat(roadWidth);
    if (plotArea && maxLength) {
      if (value > maxLength) {
        setError("plotArea", {
          type: "manual",
          message: `Plot Area should not exceed ${maxLength} sqmt.`,
        });
        setOpen(true);
        setAreaError(true);
        setIsFormDiabled(true);
        return;
      } else {
        setAreaError(false);
        setIsFormDiabled(false);
        setOpen(false);
      }
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Retail Shop") {
      if (value < 10) {
        setError("plotArea", {
          type: "manual",
          message: `The minimum required plot area is ${10.0} sqmt.`,
        });
        setIsFormDiabled(true);
        return;
      } else {
        clearErrors("plotArea");
        setIsFormDiabled(false);
      }
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Non-Built-up area") {
      if (value < 35) {
        setError("plotArea", {
          type: "manual",
          message: `The minimum required plot area is ${35.0} sqmt.`,
        });
        setIsFormDiabled(true);
        return;
      } else {
        clearErrors("plotArea");
        setIsFormDiabled(false);
      }
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Built-up area") {
      if (row < 4) {
        setError("descriptionOfLand.landLength", {
          type: "manual",
          message: `The minimum required road width is ${4.0} sqmt.`,
        });
        setIsFormDiabled(true);
        setWidthError(true);
        setOpen(true);
        return;
      } else {
        clearErrors("descriptionOfLand.landLength");
        setIsFormDiabled(false);
        setOpen(false);
        setWidthError(false);
      }
    }
    if (watchSchemeType === "Non Scheme" && watch("activityProposed") === "Row House-Single unit" && watchDevelopmentArea === "Non-Built-up area") {
      if (row < 9) {
        setError("descriptionOfLand.landLength", {
          type: "manual",
          message: `The minimum required road width is ${9.0} sqmt.`,
        });
        setWidthError(true);
        setIsFormDiabled(true);
        setOpen(true);
        return;
      } else {
        clearErrors("descriptionOfLand.landLength");
        setIsFormDiabled(false);
        setOpen(false);
        setWidthError(false);
      }
    }
    if (watchplotinMelaArea === "yes") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    }
    if (watchplotSubdivided === "yes") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    }
    if (watchplotinColonies === "yes") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    }
    if (watchContainFAR === "yes") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    }
    if (watchZoneType === "Any Others") {
      setOpen(true);
      setIsFormDiabled(true);
      return;
    } else {
      clearErrors("plotArea");
      setIsFormDiabled(false);
    }
  }, [
    plotArea,
    maxLength,
    watchplotinMelaArea,
    watchContainFAR,
    watchplotSubdivided,
    watchplotinColonies,
    watchZoneType,
    roadWidth,
    setError,
    clearErrors,
  ]);

  useEffect(() => {
    if (watchSchemeType === "Non Scheme") {
      setValue("layoutsanctionDate", null);
      setValue("layoutsanctionNumber", null);
      setValue("schemeName", null);
      setValue("proposalType", null);
    } else {
      setValue("descriptionOfLand.landLength", null);
      setValue("descriptionOfLand.landMark", null);
      setValue("descriptionOfLand.landAddress", null);
    }
  }, [watchSchemeType]);

  console.log(formData, "formDataaaa");

  useEffect(() => {
    // auto-fill net plot area ONLY if empty or greater than plot area
    if (!isNetAreaTouched) {
      setValue("totalProposedArea", plotArea, {
        shouldValidate: false,
        shouldDirty: false, // 🔥 prevents two-way update
      });
    }
  }, [plotArea, isNetAreaTouched]);

  return (
    <section className="groupContainer2">
      {/* {isFormDisabled && (
        <div
          style={{
            padding: "20px",
            backgroundColor: "#ffebee",
            borderRadius: "4px",
            margin: "20px 0",
            textAlign: "center",
            fontWeight: "bold",
            color: "red",
          }}
        >
          You cannot apply for Self-Certification as your plot is in a restricted area
        </div>
      )} */}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h4 className="formHeading common-header-sec">Low-Risk Category</h4>
          </div>
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Application Form")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            {!isDa && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={"Select Unit"}
                    inputLabel="Select unit"
                    placeholder="Select unit"
                    name="selectedUnit"
                    type="searchSelect"
                    data={SortingAlphabatically(avpUnits)}
                    defaultValue={formData?.selectedUnit || ""}
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                {watchUnit ? (
                  <Col>
                    <InputWrapper
                      control={control}
                      label={"Select City"}
                      inputLabel="Select city"
                      placeholder="Select city"
                      name="selectedCity"
                      type="searchSelect"
                      data={SortingAlphabatically(avpCities)}
                      defaultValue={formData?.selectedCity}
                      mandatory
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      disabled={isEmployee}
                    />
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>
            )}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Name of Authority"
                  name="selectedOffice"
                  type="selectInput"
                  placeholder={"Select Development Authority"}
                  mandatory
                  data={SortingAlphabatically(officesList)}
                  defaultValue={formData?.selectedOffice}
                  disabled={isFormDisabled || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label="Scheme Type"
                  inputLabel="Select Scheme Type"
                  placeholder="Select Scheme Type"
                  name="descriptionOfLand.schemeType"
                  type="searchSelect"
                  data={SortingAlphabatically(schemeTypeList)}
                  mandatory
                  defaultValue={formData?.descriptionOfLand?.schemeType}
                  disabled={isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  //label="Is your plot in the mela area declared under the Uttar Pradesh Melas Act, 1938 or in unauthoritized layouts/ colonies or plot has been subdivided?"
                  label="Is your plot in the mela area declared under the Uttar Pradesh Melas Act, 1938 ?"
                  name="plotinMelaArea"
                  type="radioButton"
                  mandatory
                  // disabled={isFormDisabled}
                  data={yesOrNo}
                  defaultValue={formData?.plotinMelaArea}
                  disabled={isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  sx={{ height: "50px" }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Has your plot been subdivided?"
                  name="plotSubdivided"
                  type="radioButton"
                  mandatory
                  // disabled={isFormDisabled}
                  data={yesOrNo}
                  defaultValue={formData?.plotSubdivided}
                  disabled={isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Is your plot in unauthorized layouts/ colonies ?"
                  name="plotinColonies"
                  type="radioButton"
                  mandatory
                  // disabled={isFormDisabled}
                  data={yesOrNo}
                  defaultValue={formData?.plotinColonies}
                  disabled={isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Name of Owner"
                  placeholder="Enter Name"
                  name="landInfo.owners.[0].name"
                  type="textInput"
                  mandatory
                  disabled={isFormDisabled || isEmployee}
                  defaultValue={formData?.landInfo?.owners?.[0]?.name}
                  onlyAlphabet={true}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "Only alphabets are allowed",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label="Son/Wife/Daughter of"
                  placeholder="Care Of"
                  name="landInfo.owners.[0].fatherOrHusbandName"
                  type="textInput"
                  mandatory
                  disabled={isFormDisabled || isEmployee}
                  onlyAlphabet={true}
                  defaultValue={formData?.landInfo?.owners?.[0]?.fatherOrHusbandName}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "Only alphabets are allowed",
                    },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Address for Correspondence"
                  placeholder="Enter Address"
                  name="landInfo.owners.[0].correspondenceAddress.address"
                  type="textInput"
                  mandatory
                  disabled={isFormDisabled || isEmployee}
                  defaultValue={formData?.landInfo?.owners?.[0]?.correspondenceAddress?.address}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Mobile No")}
                  control={control}
                  placeholder={t("Mobile No")}
                  mobileNumber
                  mandatory
                  disabled={true}
                  type="textInput"
                  name="landInfo.owners.[0].mobileNumber"
                  defaultValue={formData?.landInfo?.owners?.[0]?.mobileNumber}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("MobileNo"),
                      message: "Please enter valid mobile no",
                    },
                  }}
                  maxLength={10}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label="Aadhaar Number"
                  control={control}
                  placeholder="Enter Aadhaar Number"
                  name="landInfo.owners.[0].aadhaarNumber"
                  defaultValue={formData?.landInfo?.owners?.[0]?.aadhaarNumber}
                  type="textInput"
                  mandatory
                  disabled={isFormDisabled || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("AadharNo"),
                      message: "Please enter valid Aadhaar no",
                    },
                  }}
                  maxLength={12}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(permissionTypeList)}
                  label={t("Type of Permission")}
                  placeholder={t("Select Type of Permission")}
                  name="permissionType"
                  defaultValue={formData?.permissionType}
                  type="selectInput"
                  mandatory
                  disabled={isFormDisabled || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={isScheme ? t(`Land Use as per Layout Plan`) : t("Land Use as per Master Plan")}
                  placeholder={t("Select Type of Land Use")}
                  name="zoneType"
                  defaultValue={formData?.zoneType}
                  type="selectInput"
                  mandatory
                  disabled={isEmployee}
                  data={[
                    { code: "Residential", name: "Residential" },
                    { code: "Commercial", name: "Commercial" },
                    { code: "Any Others", name: "Any Others" },
                  ]}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={watchZoneType === "Residential" ? SortingAlphabatically(subUsesTypeList) : subUseCommercialList}
                  label={isScheme ? t("Land Sub Use as per Layout Plan") : t("Land Sub Use as per Master Plan")}
                  placeholder={t("Select Type of Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.subZoneType}
                  type="selectInput"
                  mandatory
                  disabled={isFormDisabled || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse}
                  type="selectInput" // Changed to selectInput for better UX
                  mandatory
                  disabled={isFormDisabled || isEmployee}
                  data={[
                    { code: "Residential", name: "Residential" },
                    { code: "Commercial", name: "Commercial" },
                  ]}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Proposed Activity")}
                  placeholder={t("Select Type of proposed activity")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed || "Row Houses"}
                  type="textInput"
                  mandatory
                  disabled={true}
                  // Always disabled since it's auto-set
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Development Area")}
                  placeholder={t("Select Development Area")}
                  name="developmentArea"
                  defaultValue={formData?.developmentArea}
                  type="selectInput"
                  mandatory
                  disabled={isFormDisabled || isEmployee}
                  maxLength={maxLength} // ✅ restrict input
                  data={developmentAreaOption}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label="Does proposal contain Purchasable FAR?"
                  name="containFAR"
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  disabled={isEmployee}
                  defaultValue={formData?.containFAR}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Plot Area (sqmt.)")}
                  placeholder={t("Enter Plot Area")}
                  name="plotArea"
                  defaultValue={formData?.plotArea}
                  type="specialChar"
                  allowedChars="."
                  decimalScale={2}
                  onlyNumeric={true}
                  mandatory
                  disabled={isEmployee}
                  maxLength={maxLength} // ✅ restrict input
                  onBlur={(e) => {
                    const value = parseFloat(e.target.value);
                    if (maxLength && value > parseFloat(maxLength)) {
                      alert(`Plot Area should not exceed ${maxLength} sqmt.`);
                    }
                  }}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("PlotArea"),
                      message: "Please enter valid area",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={isScheme ? "Plot No." : "Plot No./Khasra No."}
                  placeholder={isScheme ? t("Enter Plot No.") : t("Plot No./Khasra No.")}
                  name="plotNo"
                  defaultValue={formData?.plotNo}
                  type="specialChar"
                  allowedChars="/,-&"
                  // onlyNumeric={true}
                  mandatory
                  disabled={isFormDisabled || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "Please Enter Plot No.",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              {/* <Col>
                <InputWrapper
                  control={control}
                  label={"Plot Details"}
                  placeholder={t("Select Plot Details")}
                  name="plotDetails"
                  defaultValue={formData?.plotDetails || ""}
                  type="selectInput"
                  mandatory
                  disabled={isFormDisabled}
                  data={plotsDropdowns}
                  validation={{
                    required: {
                      value: true,
                      message: "Please select plot details type",
                    },
                  }}
                />
              </Col> */}
              {/* <Col>
                <InputWrapper
                  control={control}
                  label={watchPlotDetail === "Plot No." ? "Plot No." : watchPlotDetail === "Khasra No." ? "Khasra No." : "Araji No."}
                  placeholder={t("Select Plot Details")}
                  name={watchPlotDetail === "Plot No." ? "plotNo" : watchPlotDetail === "Khasra No." ? "khasraNo" : "ArajiNo"}
                  defaultValue={formData?.plotDetails || ""}
                  type="textInput"
                  mandatory
                  disabled={isFormDisabled}
                  validation={{
                    required: {
                      value: true,
                      message: "Please select plot details type",
                    },
                  }}
                />
              </Col> */}
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Builtup Area (sqmt.)")}
                  placeholder={t("Enter built up area")}
                  name="totalBuildUpArea"
                  defaultValue={formData?.totalBuildUpArea}
                  type="specialChar"
                  decimalScale={2}
                  allowedChars="."
                  onlyNumeric={true}
                  mandatory
                  disabled={isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("PlotArea"),
                      message: "Please enter valid area",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Net Plot Area (sqmt.)")}
                  placeholder={t("Enter net plot area")}
                  name="totalProposedArea"
                  defaultValue={formData?.totalProposedArea}
                  type="specialChar"
                  allowedChars="."
                  onlyNumeric={true}
                  decimalScale={2}
                  mandatory
                  disabled={isEmployee}
                  onChange={() => setIsNetAreaTouched(true)}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    pattern: {
                      value: Digit.Utils.getPattern("PlotArea"),
                      message: "Please enter valid area",
                    },
                    validate: (value) => {
                      const netArea = parseFloat(value);
                      const plot = parseFloat(plotArea);

                      if (!plot || isNaN(netArea)) return true;

                      return netArea <= plot || "Net Plot Area should be equal to or less than Plot Area";
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={updistricts}
                  label={t("District")}
                  placeholder={t("Select District")}
                  defaultValue={formData?.district}
                  name={`district`}
                  type="selectInput"
                  mandatory
                  disabled={isFormDisabled || (watchDistrict && isDa) || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>

              <Col>
                {isScheme ? (
                  <InputWrapper
                    control={control}
                    data={SortingAlphabatically(proposedSite)}
                    label={t("Proposed Site")}
                    placeholder={t("Proposed Site")}
                    name="proposalType"
                    defaultValue={formData?.proposalType}
                    type="selectInput"
                    mandatory
                    disabled={isFormDisabled || isEmployee}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                ) : (
                  <InputWrapper
                    label="Land Address"
                    control={control}
                    placeholder="Enter Land Address"
                    defaultValue={formData?.descriptionOfLand?.landAddress}
                    name="descriptionOfLand.landAddress"
                    type="specialChar"
                    allowedChars="_&:,/. -"
                    mandatory
                    disabled={isFormDisabled || isEmployee}
                    maxLength={30000}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                )}
              </Col>
            </Row>

            {/* {watchPlanOn === "Others" && watchPlotDetail !== "Plot No." && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Tehsil")}
                    control={control}
                    placeholder={t("Enter Tehsil")}
                    name="tehsil"
                    defaultValue={formData?.tehsil}
                    type="selectInput"
                    data={SortingAlphabatically(tehsils)}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isFormDisabled}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    label={t("Village")}
                    control={control}
                    placeholder={t("Enter Village")}
                    name="revenueVillage"
                    defaultValue={formData?.revenueVillage}
                    type="selectInput"
                    data={SortingAlphabatically(villages)}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isFormDisabled}
                  />
                </Col>
              </Row>
            )} */}
            {/* <Row>
              {watchPlanOn === "Others" && watchPlotDetail === "Plot No." && (
                <Col>
                  <InputWrapper
                    label={t("Mohalla Name")}
                    control={control}
                    placeholder={t("Enter Mohalla Name")}
                    name="revenueVillageMohal"
                    defaultValue={formData?.revenueVillageMohal}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
              <Col></Col>
            </Row> */}

            <React.Fragment>
              <Row>
                <Col>
                  {isScheme && schemeNames?.length > 1 ? (
                    <InputWrapper
                      label="Scheme Name"
                      control={control}
                      placeholder="Select Scheme Name"
                      defaultValue={formData?.schemeName}
                      name="schemeName"
                      type="selectInput"
                      mandatory
                      disabled={isFormDisabled || isEmployee}
                      data={SortingAlphabatically(schemeNames) || SortingAlphabatically(schemeNameList)}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  ) : (
                    <InputWrapper
                      label="Nearby Landmark"
                      control={control}
                      placeholder="Enter Nearby Landmark"
                      defaultValue={formData?.descriptionOfLand?.landMark}
                      name="descriptionOfLand.landMark"
                      type="specialChar"
                      allowedChars="_&:,/. -"
                      mandatory
                      required
                      disabled={isFormDisabled || isEmployee}
                      maxLength={25}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  )}
                </Col>

                {!isScheme ? (
                  <Col>
                    <InputWrapper
                      label="Access road width (RoW)"
                      control={control}
                      placeholder="Enter road width"
                      defaultValue={formData?.descriptionOfLand?.landLength}
                      name="descriptionOfLand.landLength"
                      type="textInput"
                      mandatory
                      required
                      disabled={isEmployee}
                      maxLength={25}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                        pattern: {
                          value: Digit.Utils.getPattern("NonZeroAmount"),
                          message: "Please enter valid width",
                        },
                      }}
                    />
                  </Col>
                ) : (
                  <Col></Col>
                )}
              </Row>
              {isScheme && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Layout Sanction No.")}
                      control={control}
                      placeholder={t("Enter layout sanction number")}
                      name="layoutsanctionNumber"
                      defaultValue={formData?.layoutsanctionNumber}
                      type="textInput"
                      disabled={isEmployee}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      label={t("Layout Sanction Date")}
                      control={control}
                      placeholder={t("Select Layout Sanction date")}
                      name="layoutsanctionDate"
                      defaultValue={formData?.layoutsanctionDate}
                      type="datePicker"
                      disableFuture={true}
                      disabled={isEmployee}
                    />
                  </Col>
                </Row>
              )}
            </React.Fragment>
            {/* <div className="formContainer">
              <FormControlLabel
                style={{ padding: "10px 15px" }}
                control={
                  <Checkbox
                    name="declaration"
                    control={control}
                    onChange={handleDeclarationChange}
                    disabled={isFormDisabled}
                    rules={{ required: "You must agree to the terms and conditions" }}
                  />
                }
                label={
                  <span>
                    I, {Digit.UserService.getUser()?.info?.name || "User"} ,{t("DECLARATION_SELF_CERTIFICATION_APPLICATION_FORM")}{" "}
                  </span>
                }
              />
            </div> */}
            {/* <Row>
              <Col>
                <InputWrapper
                  label={t("Estimated Cost (INR)")}
                  control={control}
                  placeholder={t("Enter Estimated Cost")}
                  name="plotInfo.estimatedCost"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.plotInfo?.estimatedCost}
                  disabled={isEmployee}
                  type="textInput"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                
              </Col>
            </Row> */}

            <Modal open={open} onClose={() => { }} closeAfterTransition slots={{ backdrop: Backdrop }} slotProps={{ backdrop: { timeout: 500 } }}>
              <Fade in={open}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 450,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                    outline: "none",
                  }}
                >
                  <Typography id="modal-modal-title" variant="h6" fontWeight="bold" gutterBottom sx={{ textAlign: "center" }}>
                    Not Permitted
                  </Typography>

                  {watchContainFAR === "yes" && (
                    <Typography sx={{ mt: 2 }}>
                      Purchasable FAR is not allowed through Self-certification via registration.
                      <br />
                      Kindly submit your application using the normal Map Submission process.
                    </Typography>
                  )}

                  {(watchZoneType === "Any Others" ||
                    watchplotinMelaArea === "yes" ||
                    watchplotinColonies === "yes" ||
                    watchplotSubdivided === "yes") && (
                      <Typography sx={{ mt: 2 }}>Please submit your proposal through normal Map Submission process.</Typography>
                    )}

                  {areaerror && (
                    <Typography sx={{ mt: 2 }}>
                      Plot area more than {primaryUse === "Residential" ? 100 : 30} sqmt. is not permitted for Self-certification via registration.
                      <br />
                      Kindly submit your application using the normal Map Submission process.
                    </Typography>
                  )}
                  {widtherror && (
                    <Typography sx={{ mt: 2 }}>
                      Road width less than {watchDevelopmentArea === "Built-up area" ? 4 : 9} mtr. is not permitted for Self-certification via
                      registration.
                      <br />
                      Kindly submit your application using the normal Map Submission process.
                    </Typography>
                  )}

                  <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
                    <button
                      type="button"
                      onClick={handleClose}
                      style={{
                        backgroundColor: "rgb(21, 124, 179)",
                        color: "#fff",
                        border: "none",
                        borderRadius: "8px",
                        padding: "10px 24px",
                        cursor: "pointer",
                        fontSize: "16px",
                        fontWeight: "500",
                        transition: "background-color 0.3s ease",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "rgb(15, 104, 155)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "rgb(21, 124, 179)";
                      }}
                    >
                      OK
                    </button>
                  </Box>
                </Box>
              </Fade>
            </Modal>
          </Container>
        </div>

        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                disabled={!declarationChecked && isFormDisabled}
                color="success"
                size="medium"
                label="Save"
                type="submit"
                sx={{ backgroundColor: "#157CB3" }}
              />
            </div>
          </div>
        )}
      </form>
      {showToast && <Toast error={showToast.key} label={t(showToast.message)} onClose={() => setShowToast(null)} isDleteBtn={true} />}
    </section>
  );
};

export default Step1;
